import _ from "lodash-es";

export function extractAndDistinctLangMaps(gameList: object | null | undefined) {
  const langMaps = _.flatMap(gameList, 'lang_map');
  const distinctLangMaps = _.uniqBy(langMaps, 'target');
  return distinctLangMaps;
}
